// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"a14c75ff","229":"48aae288","243":"3a08981f","416":"6dfaeee8","674":"292c9d56"}[chunkId] + ".chunk.js";
};